import React, { useState, useContext } from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import LanguageContext, { strings } from '../../contexts/language';
import { PiCheckCircleLight } from "react-icons/pi";

import api from '../../services/api';

export default function InscricaoImprensa() {
    const { language } = useContext(LanguageContext);
    const t = strings[language] || strings.pt;
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError]     = useState('');

    // Alteração 6: apenas os campos do ano passado
    const [form, setForm] = useState({
        name: '',
        email: '',
        phone: '',
        organization: '',
        participation_type: 'online', 
    });
    const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

    async function submit(e) {
        e.preventDefault();
        if (
            !form.name ||
            !form.email ||
            !form.organization ||
            !form.participation_type
        ) { setError(t.required_field); return; }
        setLoading(true); setError('');
        try {
            const r = await api.post('/register', {
                ...form,
                type: 'press',
                lang: language === 'en' ? 'en' : 'br',
            });
            if (!r.data.status) setError(r.data.content);
            else setSuccess(true);
        } catch(err) { setError(`${t.register_error}, ${err.message}`); }
        setLoading(false);
    }

    if (success) return (
        <div className="page"><Header />
            <main style={{ flex:1, display:'flex', alignItems:'center', justifyContent:'center', padding:'60px 20px' }}>
                <div style={{ maxWidth:500, textAlign:'center' }}>
                    <div style={{ fontSize:60, marginBottom:20 }} className="color_3"><PiCheckCircleLight size={80} /></div>
                    <h3 className="color_3">{t.register_success}</h3>
                </div>
            </main>
        <Footer /></div>
    );

    return (
        <div className="page"><Header />
            <main style={{ flex:1, padding:'40px 20px' }}>
                <div style={{ maxWidth:600, margin:'0 auto' }}>
                    {/* Alteração 6: título "Inscrição Imprensa" */}
                    <h2 className="section-title color_5 text-center">
                        {language === 'en' ? 'Press Registration' : 'Inscrição Imprensa'}
                    </h2>
                    <h5 className="text-center text-danger fw-bold mb-10">
                        {language === 'en' ? 'IN-PERSON REGISTRATION - CLOSED ON THE WEBSITE' : 'INSCRIÇÕES PRESENCIAIS - ENCERRADAS NO SITE'}
                    </h5>
                    <p className="text-center mb-30">
                        {language === 'en' ? '(Registration for the in-person event is still open, but only at the event venue please arrive early—space is limited)' : '(Inscrições para o evento presencial seguem abertas, mas somente no local do evento - chegue com antecedência - vagas limitadas)'}
                    </p>
                    
                    <form onSubmit={submit} className={loading ? 'loading' : ''}>
                        <div className="mb-20" style={{ width:'100%' }}>
                            <label>{t.register_participation} *</label>
                            <div className="options-subscribe">
                                {['online'].map(v => (
                                    <label key={v} style={{ display:'flex', alignItems:'center', gap:8, cursor:'pointer', fontWeight:600, whiteSpace: 'nowrap' }}>
                                        <input
                                            type="radio"
                                            name="participation_type"
                                            value={v}
                                            checked={form.participation_type === v}
                                            onChange={() => set('participation_type', v)}
                                        />
                                        {v === 'online' ? t.register_online : t.register_presential}
                                    </label>
                                ))}
                            </div>
                        </div>

                        <div className="d-input mb-20" style={{ width:'100%' }}>
                            <label>{t.register_name} *</label>
                            <input type="text" value={form.name} onChange={e => set('name', e.target.value)} required />
                        </div>

                        <div className="d-input mb-20" style={{ width:'100%' }}>
                            <label>{t.register_email} *</label>
                            <input type="email" value={form.email} onChange={e => set('email', e.target.value)} required />
                        </div>

                        <div className="d-input mb-20" style={{ width:'100%' }}>
                            <label>{t.register_phone}</label>
                            <input type="tel" value={form.phone} onChange={e => set('phone', e.target.value)} />
                        </div>

                        <div className="d-input mb-20" style={{ width:'100%' }}>
                            <label>{language === 'en' ? 'Media outlet / vehicle' : 'Veículo de comunicação'} *</label>
                            <input type="text" value={form.organization} onChange={e => set('organization', e.target.value)} required />
                        </div>

                        {error && <div className="w-100 text-center error mb-20">{error}</div>}
                        <button type="submit" className="btn-send btn-modern w-100" disabled={loading}>
                            {loading ? (language === 'en' ? 'Sending...' : 'Enviando...') : t.btn_send}
                        </button>
                        <p className="home-lgpd-text mt-20">{t.register_lgpd}</p>
                    </form>
                </div>
            </main>
        <Footer /></div>
    );
}
